import React from 'react'
import { GenericPopUp } from '../../../components/molecules/GenericPopUp';
import { Box, Button, Grid, makeStyles, Typography } from '@material-ui/core'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    table: {
      width:"100%"
    },
    root: {
      backgroundColor: "#2f4554",
      margin: "px 0",
      textAlign:'center',
      color: "white",
      "&:hover": {
        backgroundColor: "rgb(0, 183, 196)"
      },
      "&:disabled": {
        backgroundColor: "gray"
      }
    }
  });

export const PopUpSuccessSolicitud = ({show, onHandleShowPopUp,verSubtitulo = true, maxwidth='md'}) => {

    const { t } = useTranslation();
    const classes = useStyles();

  return (
    <>
        <GenericPopUp maxwidth={maxwidth} show={show} handleShowPopUp={onHandleShowPopUp} showCancel={false} Children={
            <Grid container justifyContent='center' alignItems='center' direction='column' style={{paddingBottom:'50px'}}>
                <Grid container item justifyContent='center' alignItems='center' direction='column'>
                    <Grid style={{margin:'20px 0px'}}>
                        <CheckCircleOutlineIcon fontSize='large'/>
                    </Grid>
                    <Typography
                        style={{fontWeight: "bolder",fontSize: "15px",color: "#2f4554",maxWidth:'250px', textAlign:'center'}}
                    >
                       {t('cambios_guardados_title')}
                    </Typography>
                </Grid>
                <Button
                        type="button"
                        variant="contained"
                        className={classes.root}
                        style={{textAlign:'center', marginTop:'35px', padding:'10px 40px'}}
                        onClick={() =>{
                            onHandleShowPopUp(false);
                        }
                        }
                        >
                          {t("entendido")}
                </Button>
            </Grid>
        }/>
    </>
  )
}
